// pages/ContactsAndCompanyInfoEditing/components/CountryCodeSelector/index.js
import React, { useState, useRef, useEffect } from 'react';
import { countryCodes } from './countryCodes';
import styles from './styles.module.scss';

const CountryCodeSelector = ({ 
  selectedCountry, 
  onCountrySelect, 
  className = '' 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);
  const triggerRef = useRef(null);

  const filteredCountries = countryCodes.filter(country =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    country.code.includes(searchTerm)
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
          triggerRef.current && !triggerRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleCountrySelect = (country) => {
    onCountrySelect(country);
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div className={`${styles.countryCodeSelector} ${className}`}>
      <button
        ref={triggerRef}
        type="button"
        className={styles.trigger}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className={styles.selectedCountry}>
          <span className={styles.flag}>{selectedCountry.flag}</span>
          <span className={styles.code}>{selectedCountry.code}</span>
          <span className={styles.caret}>▼</span>
        </div>
      </button>

      {isOpen && (
        <div ref={dropdownRef} className={styles.dropdown}>
          <div className={styles.searchContainer}>
            <input
              type="text"
              placeholder="Search country..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.searchInput}
              autoFocus
            />
          </div>
          
          <div className={styles.countryList}>
            {filteredCountries.length > 0 ? (
              filteredCountries.map((country) => (
                <div
                  key={country.code}
                  className={`${styles.countryOption} ${
                    selectedCountry.code === country.code ? styles.selected : ''
                  }`}
                  onClick={() => handleCountrySelect(country)}
                >
                  <span className={styles.optionFlag}>{country.flag}</span>
                  <span className={styles.optionCode}>{country.code}</span>
                  <span className={styles.optionName}>{country.name}</span>
                </div>
              ))
            ) : (
              <div className={styles.noResults}>
                No countries found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CountryCodeSelector;